/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

/**
 * All of the possible `ChipState*`'s.
 */
export type ChipState = ChipStateInvalid | ChipStateWarning;

/**
 * The Chip invalid state type.
 */
export type ChipStateInvalid = typeof CHIP_STATE_INVALID;

/**
 * The Chip warning state type.
 */
export type ChipStateWarning = typeof CHIP_STATE_WARNING;

/**
 * The Chip invalid state constant.
 */
export const CHIP_STATE_INVALID = `invalid`;

/**
 * The Chip warning state constant.
 */
export const CHIP_STATE_WARNING = `warning`;
